import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "visitor-entry-notification" as const;

export type VisitorEntryNotificationEventData = {
  eventId: string;
  userId: string;
  recipientUserIds: string[];
  visitorName: string;
  eventName: string;
  eventImageId: string | null;
};

export type VisitorEntryNotificationEvent = AppEvent<
  typeof eventName,
  VisitorEntryNotificationEventData
>;

export const isVisitorEntryNotificationEvent = (
  event: AnyAppEvent
): event is VisitorEntryNotificationEvent => event.name === eventName;

export { eventName as visitorEntryNotification };
